import React, { useContext } from 'react';
import {
  AuthContext,
  IAuthContext,
} from '../../../state/providers/AuthProvider';
import styled from 'styled-components';
import split from 'lodash/split';

export const UserNameContainer = styled.div``;
const UserName = () => {
  const context: IAuthContext = useContext(AuthContext);
  const email = split(context.emailId, '@', 1).toString();
  return (
    <UserNameContainer>{`${context.customerFullName} (${email})`}</UserNameContainer>
  );
};

export default UserName;
